module.exports = __webpack_public_path__ + "img/maersk.96b7c52e.png";